import { REGEX_EQUAION_TO_CHECK_FOR_LINKS } from '../../consts/consts';
import './linkPreview.scss';

export const linkPreviewIframeTemplate = (model) => {
	const iframe = document.getElementById('engtIframe');
	const parent = iframe?.parentElement;
	parent?.removeChild(iframe);
	const { msg, message_id } = model;

	const match = msg.match(REGEX_EQUAION_TO_CHECK_FOR_LINKS);
	const extractedLink = match ? match[1] : null;
	const linkIframeTag = extractedLink
		? msg.replace(
				/<a /g,
				` <iframe class="engt-iframe" id="engtIframe" src=${extractedLink}></iframe>
		<a target="_blank" class="engt-link" data-link-preview-id=${message_id} `
		  )
		: msg.replace(/<a /g, `<a target="_blank" class="engt-tab-selectable" data-link-preview-id=${message_id} `);
	/* html */
	const wrapper = `<div class="engt-msg engt-msg-bot engt-msg-border-bot engt-msg-iframe">
        <span class="engt-link">${linkIframeTag}</span>
</div> `;

	return wrapper;
};
